module.exports = __webpack_public_path__ + "images/img_1_2-1bf2d11cd4.png";